// Werte müssen mit Strings im ProlixPro Backend übereinstimmen
export const PROLIX_ERROR_IDENTIFIER = 'prolixErrorIdentifier';
export const PROLIX_ERROR_MESSAGE = 'message';
export const NOT_CURRENT_CART_ERROR = 'NOT_CURRENT_CART_ERROR';
export const OCI_SESSION_ERROR = 'OCI_SESSION_ERROR';
export const PROLIX_APPLICATION_EXCEPTION = 'PROLIX_APPLICATION_EXCEPTION';
export const HAS_BLOCKED_POSITIONS = 'HAS_BLOCKED_POSITIONS';

export type ProlixApplicationError = {
  // Modellierung der Response, wenn ProlixPro eine SilentApplicationException wirft
  [PROLIX_ERROR_IDENTIFIER]: string; // zur Zeit ein fixer Wert für alle SilentApplicationExceptions aus Prolix, könnte aber in Zukunft ein Error-Code vom Prolix Backend sein ...
  [PROLIX_ERROR_MESSAGE]: string;
}
export function isProlixProApplicationError(data: any): data is ProlixApplicationError {
  return (
    typeof data === 'object' &&
    data !== null &&
    PROLIX_ERROR_IDENTIFIER in data &&
    typeof data[PROLIX_ERROR_IDENTIFIER] === 'string' &&
    PROLIX_ERROR_MESSAGE in data &&
    typeof data[PROLIX_ERROR_MESSAGE] === 'string'
  );
}